import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { isRole } from "../redux/selectors/authSelector";

const ConvertToDMY = (date) => {
    if (!date) return '';
    return dayjs(date).format('DD/MM/YYYY');
};

const ConvertToDMYHIS = (date) => {
    if (!date) return '-';
    return dayjs(date).format('DD/MM/YYYY hh:mm a');
};

const Convert_toSpace = (str) => {
    if (!str) return '';
    return str.replace(/_/g, ' ');
}

const CheckPermission = (allPermissions, requestedPermission) => {
    let role=useSelector(isRole)
    // if(!allPermissions ||(allPermissions?.length === 0 && role=="schooladmin" )) return true;
    if(!allPermissions  && role=="schooladmin" ) return true;

    if ( allPermissions?.includes(requestedPermission)) return true;
    return false;
}

const CheckPermissionForAdmin = (allPermissions, requestedPermission) => {
    let role=useSelector(isRole)
    console.log("allPermissions>>>",!allPermissions)
    if(!allPermissions  && role=="admin" ) return true;
    if ( allPermissions?.includes(requestedPermission)) return true;
    return false;
}

export {
    ConvertToDMY,
    ConvertToDMYHIS,
    Convert_toSpace,
    CheckPermission,
    CheckPermissionForAdmin
}